import React from 'react';

const SpeakSection = ({ isDarkMode = true }) => {
    const talks = [
        {
            title: "Conversational UI",
            venue: "UX Tokyo, Awwwards",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="1.5"
                     className={`transition-all duration-500 group-hover:scale-110 
                               ${isDarkMode ? 'opacity-75' : 'opacity-90'} 
                               group-hover:stroke-blue-500`}>
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <circle cx="12" cy="12" r="2"></circle>
                </svg>
            )
        },
        {
            title: "Designing for attention",
            venue: "Wix Tel-Aviv, UX Salon",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="1.5"
                     className={`transition-all duration-500 group-hover:scale-110 
                               ${isDarkMode ? 'opacity-75' : 'opacity-90'} 
                               group-hover:stroke-purple-500`}>
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="3"></circle>
                </svg>
            )
        },
        {
            title: "Meaningful Motion",
            venue: "Amuse, Awwwards, Push",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="1.5"
                     className={`transition-all duration-500 group-hover:scale-110 
                               ${isDarkMode ? 'opacity-75' : 'opacity-90'} 
                               group-hover:stroke-indigo-500`}>
                    <path d="M4 4h16v16H4z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                </svg>
            )
        },
        {
            title: "Designing choice",
            venue: "Push 16, Amuse, Web Expo",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="1.5"
                     className={`transition-all duration-500 group-hover:scale-110 
                               ${isDarkMode ? 'opacity-75' : 'opacity-90'} 
                               group-hover:stroke-cyan-500`}>
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4M12 8h.01"></path>
                </svg>
            )
        },
        {
            title: "Rethinking Content Creation",
            venue: "Amuse, Awwwards",
            icon: (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="1.5"
                     className={`transition-all duration-500 group-hover:scale-110 
                               ${isDarkMode ? 'opacity-75' : 'opacity-90'} 
                               group-hover:stroke-sky-500`}>
                    <polyline points="4 17 10 11 4 5"></polyline>
                    <line x1="12" y1="19" x2="20" y2="19"></line>
                </svg>
            )
        }
    ];

    return (
        <div className="mt-12 sm:mt-16 md:mt-24 lg:mt-32">
            {/* Header */}
            <div className="px-4 sm:px-6 md:px-8 lg:px-32">
                <div className="max-w-3xl mb-12 sm:mb-16">
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-mono tracking-tight mb-8">
                        Speak
                    </h2>
                    <p className="font-mono text-sm sm:text-base text-gray-400 leading-relaxed">
                        I'm passionate about sharing knowledge and meeting new people. I've had the opportunity to share ideas at various events around the globe.
                    </p>
                </div>
            </div>

            {/* Talks Grid */}
            <div className="px-4 sm:px-6 md:px-8 lg:px-32">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-x-24 lg:gap-y-12">
                    {talks.map((talk, index) => (
                        <div
                            key={index}
                            className="group flex items-start space-x-5 sm:space-x-6 md:space-x-7
                                     hover:translate-x-1 transition-all duration-300 ease-out cursor-pointer"
                        >
                            <div className={`w-20 h-20 sm:w-24 sm:h-24 shrink-0 flex items-center justify-center
                                           ${isDarkMode ? 'bg-[#111111] group-hover:bg-[#1a2030]' : 'bg-gray-100 group-hover:bg-gray-50'} 
                                           rounded-2xl transition-all duration-300 ease-out
                                           transform-gpu will-change-transform
                                           ${isDarkMode ? 'shadow-none' : 'shadow-sm group-hover:shadow-md'}`}>
                                {talk.icon}
                            </div>
                            <div className="py-1 flex flex-col justify-center min-h-[3rem]">
                                <p className={`font-mono font-medium mb-1.5 text-sm sm:text-base tracking-tight
                                            ${isDarkMode ? 'group-hover:text-white' : 'group-hover:text-gray-900'}`}>
                                    {talk.title}
                                </p>
                                <p className={`font-mono text-xs sm:text-sm tracking-tight
                                           ${isDarkMode ? 'opacity-60' : 'opacity-70'}`}>
                                    {talk.venue}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SpeakSection;